// Game-balance constants live as data per plan §4.
// Edit these without touching module logic.

export const IP_TIER_COEFFICIENT = 100;
export const IP_ENCHANT_COEFFICIENT = 100;

export const QUALITY_BONUS = {
  Normal: 0,
  Good: 50,
  Outstanding: 100,
  Excellent: 200,
  Masterpiece: 400,
} as const;

export const MIN_TIER = 1;
export const MAX_TIER = 8;
export const MIN_ENCHANT = 0;
export const MAX_ENCHANT = 3;
